import { render } from "./HidePaginWhenThereIsOnePg.vue?vue&type=template&id=b13aaa00"
import script from "./HidePaginWhenThereIsOnePg.vue?vue&type=script&lang=ts"
export * from "./HidePaginWhenThereIsOnePg.vue?vue&type=script&lang=ts"
script.render = render

export default script